import { UploadButtonComponent } from './components/upload-button/upload-button.component';
import { TableComponent } from './components/table/table.component';
import { AttachmentPreviewModalComponent } from './components/attachment-preview-modal/attachment-preview-modal.component';
import { AttachmentListComponent } from './components/attachment-list/attachment-list.component';
import { ButtonComponent } from './components/button/button.component';
import { UploadListComponent } from './components/upload-list/upload-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from 'ngx-pagination'; // pagination module: http://michaelbromley.github.io/ngx-pagination/#/
import { ModalModule } from 'ngx-bootstrap/modal'; // Modal https://valor-software.com/ngx-bootstrap/#/modals
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FileUploadComponent } from './file-upload/file-upload.component';
import {FileUploadModule} from 'ng2-file-upload';
import { ChecklistsComponent } from './components/checklists/checklists.component';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { HistoryComponent } from './components/history/history.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { InternationalPhoneComponent } from './components/international-phone/international-phone.component';
import { WorkflowActionComponent } from './workflow-action/workflow-action.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { GmpProductDetailComponent } from './components/gmp-product-detail/gmp-product-detail.component';
import { FormlyModule } from '@ngx-formly/core';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ErisFormElementsModule } from 'eris-forms';
import { EditAnchorComponent } from './components/edit-anchor/edit-anchor.component';
import { normalTextValidator, normalTextValidatorMessage } from '../inspection/shared/validators/normal-text-validator';
import { emailValidationMessage, emailValidator } from '../inspection/shared/validators/email-validator';
import { phoneValidationMessage, phoneValidator } from '../inspection/shared/validators/phone-validator';
import { legacyFacilityValidationMessage, legacyFacilityValidator } from '../inspection/shared/validators/legacy-facility-validator';
import { noScriptInputFormlyConfig } from './validators/no-script-input.validator';
import { NoScriptInputDirective } from './directives/no-script-input.directive';
import { ErisFormModalComponent } from './components/eris-form-modal/eris-form-modal.component';
import { TimeLineComponent } from './components/time-line/time-line/time-line.component';
import {DayHourMinutePipe} from './pipes/DayHourMinutePipe';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    NgxPaginationModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    FileUploadModule,
	  ModalModule,
    ReactiveFormsModule,
    ButtonsModule,
    NgSelectModule,
    BsDropdownModule,
    FormlyModule.forRoot(),
    ErisFormElementsModule.forRoot({
      types: [
        ...(noScriptInputFormlyConfig.types || []),
        { name: "upload-list", component: UploadListComponent },
        { name: "checklists", component: ChecklistsComponent},
        { name: "checkbox", component: CheckboxComponent},
        { name: "international-phone", component: InternationalPhoneComponent},
        { name: "edit-anchor", component: EditAnchorComponent},
        { name: "gmp-product-detail", component: GmpProductDetailComponent }
      ],
      validators: [
        ...(noScriptInputFormlyConfig.validators || []),
        { name: "normal-text", validation: normalTextValidator },
        { name: "email", validation: emailValidator },
        { name: "phone", validation: phoneValidator },
        { name: "legacy", validation: legacyFacilityValidator },
      ],
      validationMessages: [
        ...(noScriptInputFormlyConfig.validationMessages || []),
        { name: "normal-text", message: normalTextValidatorMessage },
        { name: "email", message: emailValidationMessage },
        { name: "phone", message: phoneValidationMessage },
        { name: "legacy", message: legacyFacilityValidationMessage },
      ],
    }),
  ],
  declarations: [
    FileUploadComponent,
    UploadListComponent,
    ButtonComponent,
    AttachmentListComponent,
    AttachmentPreviewModalComponent,
    TableComponent,
    UploadButtonComponent,
    ChecklistsComponent,
    HistoryComponent,
    InternationalPhoneComponent,
    WorkflowActionComponent,
    GmpProductDetailComponent,
    ErisFormModalComponent,
    TimeLineComponent,
    DayHourMinutePipe,
    NoScriptInputDirective
  ],
  exports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    NgxPaginationModule,
    ModalModule,
    BsDatepickerModule,
    FileUploadComponent,
    HistoryComponent,
    WorkflowActionComponent,
    ErisFormModalComponent,
    TimeLineComponent,
    NoScriptInputDirective
  ],
  providers: [
    BsModalService
  ],
})
export class SharedModule { }
